// extracted by mini-css-extract-plugin
module.exports = {"HomePageInfo":"HomePageInfo_HomePageInfo__1b3nq","ClassInfo":"HomePageInfo_ClassInfo__wda6-","ClassImage":"HomePageInfo_ClassImage__lPjxG"};